import ApiService from '../services/ApiService';

export default class TagRepository {
    constructor() {
        this.apiService = new ApiService();
    }

    getTags(searchString) {
        return new Promise((resolve, reject) => {
            this.apiService
                .get('tags?filter[title]=' + searchString)
                .then(response => resolve(response))
                .catch(error => reject(error));
        });
    }
}
